import { country } from "@signals"
import { TOUR_TRANSLATIONS } from "../translations"

export const getCatalogueGeneralSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]
    const hasSingleCountry = country.value?.length === 1

    const steps = [
        {
            target: '[data-tour="catalogue-general-filters"]',
            title: t.catalogueGeneralFilters.title,
            content: t.catalogueGeneralFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="catalogue-general-tabs"]',
            title: t.catalogueGeneralTabs.title,
            content: t.catalogueGeneralTabs.content,
        },
        {
            target: '[data-tour="catalogue-general-num-retailer-chart"]',
            title: t.catalogueGeneralNumRetailerChart.title,
            content: t.catalogueGeneralNumRetailerChart.content,
        },
        hasSingleCountry && {
            target: '[data-tour="catalogue-general-table"]',
            title: t.catalogueGeneralTable.title,
            content: t.catalogueGeneralTable.content,
        },
        {
            target: '[data-tour="catalogue-general-num-products-chart"]',
            title: t.catalogueGeneralNumProductsChart.title,
            content: t.catalogueGeneralNumProductsChart.content,
        },
        {
            target: '[data-tour="catalogue-general-price-chart"]',
            title: t.catalogueGeneralPriceChart.title,
            content: t.catalogueGeneralPriceChart.content,
        },
    ]

    return steps.filter(Boolean)
}
